import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/components/AuthProvider';
import { supabase } from '@/integrations/supabase/client';

export function useExpressCheckout() {
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { toast } = useToast();
  const { session } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleExpress = async () => {
      const checkoutSuccess = searchParams.get('checkout');
      const sessionId = searchParams.get('session_id');

      if (checkoutSuccess === 'success' && sessionId) {
        setShowSuccessAnimation(true);
        
        setTimeout(() => {
          setShowSuccessAnimation(false);
          toast({
            title: "Welcome to BuxBox!",
            description: "Your subscription is now active. Start exploring your library!",
          });
        }, 2500);

        const emailParam = searchParams.get('email');
        try {
          let email = emailParam || null;

          if (!email) {
            const { data: emailData, error: emailError } = await supabase.functions.invoke('get-express-email', {
              body: { sessionId }
            });
            if (emailError) {
              console.warn('Failed to fetch email from session:', emailError);
            }
            email = (emailData as any)?.email || null;
          }

          if (!session && email) {
            await supabase.auth.signInWithOtp({
              email,
              options: {
                shouldCreateUser: false,
                emailRedirectTo: window.location.origin + '/'
              }
            });

            toast({
              title: "Check Your Email",
              description: "We've sent you a sign-in code to complete your setup.",
            });
          }
        } catch (err) {
          console.error('Express checkout sign-in error:', err);
          toast({
            title: "Sign-in required",
            description: "Please sign in with your checkout email to complete setup.",
          });
        } finally {
          // Clean up the URL
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.delete('checkout');
          newSearchParams.delete('session_id');
          newSearchParams.delete('email');
          setSearchParams(newSearchParams, { replace: true });
        }
      }
    };

    // Fire and forget
    void handleExpress();
  }, [searchParams, setSearchParams, toast, session]);

  return { showSuccessAnimation };
}